import React, { useCallback, useMemo, useState } from 'react';
import { Control, FieldErrors, UseFormGetValues, UseFormSetValue, useWatch } from 'react-hook-form';
import get from 'lodash/get';

import { AthleteFormValues, playerModal } from 'features/addPlayer/interface';
import { NoteModal } from 'features/playerProfile/constant';

import { PlusIcon } from 'shared/icon';
import useModal from 'shared/hooks/useModal';
import AddNoteModal from 'shared/components/modal/addNoteModal';
import { TENNIS_TOURNAMENT_OPTIONS, TOURNAMENT_OPTIONS } from 'shared/constants';
import SearchableSelect from 'shared/form/select/searchableSelect';
import { toast } from 'react-toastify';

interface IProps {
	control: Control<any>;
	errors: FieldErrors<AthleteFormValues>;
	setValue?: UseFormSetValue<any>;
	getValues: UseFormGetValues<any>;
	isTennis?: boolean;
}

export const enum Modal {
	ADDED_PLAYER = 'Added player',
	EDITOR_COMMENT = 'Editor Comment'
}

const Tournament: React.FC<IProps> = (props) => {
	const { control, errors, setValue, isTennis } = props;

	const { isOpen, type, closeModal, openModal } = useModal<playerModal>();
	const [editorComment, setEditorComment] = useState('');

	const getErrorMsg = useCallback(
		(key: string) => {
			return get(errors, `${key}.message`, '') as string;
		},
		[errors]
	);
	const tournament = useWatch({
		control,
		name: 'player_information.tournament'
	});
	const note = useWatch({
		control,
		name: 'player_information.tournament_note'
	});

	const handleAddCommentClick = () => {
		openModal(playerModal.EDITOR_COMMENT);
		//const currentComment = get(getValues(), 'player_information.tournament_note', '');
		setEditorComment(note);
	};

	const OPTIONS = useMemo(() => {
		const slicedOptions = isTennis ? TENNIS_TOURNAMENT_OPTIONS.slice(1) : TOURNAMENT_OPTIONS.slice(1);
		return slicedOptions;
	}, [isTennis]);

	return (
		<>
			<div className='flex items-center justify-between'>
				<p className='title-text'>Tournament</p>
				{tournament && (
					<div className='flex items-center cursor-pointer title-text' onClick={handleAddCommentClick}>
						<PlusIcon className='stroke-primary size-3 mr-2' />
						<p className='text-sm font-semibold text-primary'>Add Comment for Tournament</p>
					</div>
				)}
			</div>
			<div className='mb-4 flex gap-3 items-start'>
				<SearchableSelect
					placeHolder='Select Tournament'
					control={control}
					name='player_information.tournament'
					title='Tournament'
					className='max-w-[390px]'
					options={OPTIONS}
					errorMsg={getErrorMsg('player_information.tournament')}
					isStaticOptions
					required
				/>
				{/*{tournament && (
					<div className='flex items-center cursor-pointer title-text' onClick={handleAddCommentClick}>
						<PlusIcon className='stroke-primary size-3 mr-2' />
						<p className='text-sm font-semibold text-primary'>Add Comment for Tournament</p>
					</div>
				)}*/}
			</div>

			{isOpen && type === playerModal.EDITOR_COMMENT && (
				<AddNoteModal
					headerTile='Tournament note'
					subHeaderTitle={'Leave a comment for specific Tournament'}
					show={isOpen}
					onClose={() => {
						closeModal();
					}}
					isQuickNote
					initialData={{ note: editorComment }}
					formSubmit={(data: { note: string }) => {
						setEditorComment(data.note); // Update local state
						setValue && setValue('player_information.tournament_note', data.note);
						toast.success('Tournament note added successfully');
						closeModal();
					}}
					type={NoteModal.addNote}
				/>
			)}
		</>
	);
};

export default Tournament;
